import React from "react";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import { colors } from "src/colors/colors";

const CustomBtn = withStyles((theme) => {
  return {
    root: {
      "&:hover": {
        backgroundColor: "#DD0051 !important",
      },
      "&.MuiButton-root": {
        background: "#DD0071",
        color: "#fff",
        padding: "15px 142px 15px 142px",
        borderRadius: "32px",
        fontSize: "18px",
        fontWeight: 700,
        lineHeight: "26px",
        textTransform: "none",
        fontFamily: "Inter",
        [theme.breakpoints.down("md")]: {
          fontSize: "14px",
          width: "calc(100% - 16px)",
          padding: "15px 0",
          maxWidth: "364px",
        },
        "&.Mui-disabled": {
          background: "#E7E8FD",
        },
      },
    },
  };
})(Button);

//! type
interface ButtonProps {
  children: any;
  onEvent?: () => void | any;
  style?: any;
  className?: string;
  disabled?: boolean;
  type?: any;
  icon?: React.ReactNode;
  positionIconStart?: boolean;
  positionIconEnd?: boolean;
}
const useStyles = makeStyles((theme) => {
  return {
    disable: {
      background: "#E7E8FD",
    },
  };
});
const ButtonCommon = (props: ButtonProps) => {
  //! State
  const {
    children,
    onEvent,
    style,
    className,
    type,
    disabled,
    icon,
    positionIconStart,
    positionIconEnd,
    ...restProps
  } = props;
  const typebtn = type;
  const classes = useStyles();
  //! Render
  return (
    <CustomBtn
      disabled={disabled}
      onClick={onEvent}
      type={typebtn}
      className={`${className}`}
      style={{ ...style }}
      startIcon={positionIconStart && icon}
      endIcon={positionIconEnd && icon}
      {...restProps}
    >
      {children}
    </CustomBtn>
  );
};
export default ButtonCommon;
